import { AudioStep } from "@/components/mentor-profile/steps/audio-step";
import { BioStep } from "@/components/mentor-profile/steps/bio-step";
import { DisplayNameStep } from "@/components/mentor-profile/steps/display-name-step";
import { InterestsStep } from "@/components/mentor-profile/steps/interests-step";
import { LanguagesStep } from "@/components/mentor-profile/steps/languages-step";
import { ProfilePhotoStep } from "@/components/mentor-profile/steps/profile-photo-step";
import { SpotifyStep } from "@/components/mentor-profile/steps/spotify-step";
import type { WizardStepProps } from "@/components/mentor-profile/steps/types";
import { VibeStep } from "@/components/mentor-profile/steps/vibe-step";
import {
  WIZARD_BUILD_STEPS,
  type WizardBuildStep,
} from "@/lib/mentor-profile/wizard-steps";

export type WizardStepComponent = (props: WizardStepProps) => JSX.Element;

export const WIZARD_STEP_COMPONENTS: Record<
  WizardBuildStep,
  WizardStepComponent
> = {
  profile_photo: ProfilePhotoStep,
  display_name: DisplayNameStep,
  languages: LanguagesStep,
  bio: BioStep,
  spotify: SpotifyStep,
  audio: AudioStep,
  vibe: VibeStep,
  interests: InterestsStep,
};

export const WIZARD_STEP_LIST = WIZARD_BUILD_STEPS.map((id) => ({
  id,
  Component: WIZARD_STEP_COMPONENTS[id],
}));
